import React from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';
import type { RunnerId } from '@swf/generated/types/api/sports';
import { Icon } from '@swf/sports/components';
import useBetSlip from '@swf/sports/hooks/useBetSlip';

import { TXTCLI_Remove } from './RemoveButton.messages.json';
import styles from './RemoveButton.scss';

interface Props {
  runnerId: RunnerId;
}

const RemoveButton: React.FC<Props> = ({ runnerId }) => {
  const { formatMessage } = useRegulatoryIntl();
  const { removeFromBetSlip } = useBetSlip();
  const selectedPromotionPicker = useSelector(select.betSlip.getSelectedPromotionPicker);

  return (
    <button
      type="button"
      title={formatMessage(TXTCLI_Remove)}
      className={styles.button}
      onClick={() => removeFromBetSlip(runnerId)}
      disabled={Boolean(selectedPromotionPicker)}
    >
      <Icon name="close-medium" size="lg" />
    </button>
  );
};

export default RemoveButton;
